import React from 'react';
import { Link } from 'react-router-dom';
import { FaExternalLinkAlt, FaTimes } from 'react-icons/fa';
import VitalsTab from '../../Routes/AdminRoutes/PatientProfile/VitalsTab';
import ModalPortal, { MODAL_Z } from './ModalPortal';

/**
 * This patient's real vitals profile, shown over the prescription so the doctor
 * does not lose the prescription they are in the middle of writing. It renders
 * the same VitalsTab as the patient profile page rather than an iframe, so the
 * readings, charts and entry form all behave exactly as they do there.
 */
const VitalSignsModal = ({ isOpen, onClose, patientId, patientName }) => {
  if (!isOpen) return null;

  return (
    <ModalPortal isOpen={isOpen} onClose={onClose}>
    <div
      className={`fixed inset-0 ${MODAL_Z} flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4`}
      onClick={onClose}
    >
      <div
        className="flex max-h-[92vh] w-full max-w-6xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
          <div>
            <h2 className="text-lg font-bold text-slate-900">Vitals</h2>
            <p className="text-xs text-slate-500">{patientName || 'Patient vitals profile'}</p>
          </div>

          <div className="flex items-center gap-2">
            {patientId && (
              <Link
                to={`/patients/${patientId}/profile?tab=vitals`}
                className="inline-flex items-center gap-1.5 rounded-xl border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50"
              >
                <FaExternalLinkAlt className="h-3 w-3" />
                <span>Open full profile</span>
              </Link>
            )}
            <button
              onClick={onClose}
              className="rounded-xl p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
              title="Close"
            >
              <FaTimes className="h-4 w-4" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          {patientId ? (
            <VitalsTab patientId={patientId} />
          ) : (
            <p className="rounded-xl border border-amber-200 bg-amber-50 p-6 text-center text-sm text-amber-800">
              This patient has not loaded yet.
            </p>
          )}
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default VitalSignsModal;
